const overlays = {
    10: '#3333331a',
    20: '#33333333',
    30: '#3333334d',
    40: '#33333366',
    50: '#33333380',
};
export default overlays;
//# sourceMappingURL=overlays.js.map